<ng-container *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-button ttText="accusttrans_remove_matching" (ttClick)="removeChanges()" [ttSpin]="removing" ttIcon="fas fa-sync"></tt-button>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</ng-container>
